import { State } from 'business/models/Models';
import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useMemo, useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import {
  addBufferDataPoint,
  removeBufferDataPoint,
  updateBufferDataPointById,
} from 'redux/reducers/ingredientDetailReducer';
import { IStyle } from 'Styles';
import { getNewId } from 'utils/Global';
import { BUFFER_DATA_COLUMNS, BufferDataTableProps } from './utils/Constants';
import { TitrationRowRenderer } from './TitrationRowRenderer';
import { ButtonsListContainer } from 'components/Button';

export const BufferDataTable = (props: BufferDataTableProps) => {
  const { ingId, bufferDataPoints, errors } = props;
  const [selectedRows, setSelectedRows] = useState([]);
  const dispatch = useRMDispatch();

  const handleDataPointChange = (e: React.ChangeEvent<HTMLInputElement>, pointId) => {
    dispatch(
      updateBufferDataPointById({
        id: pointId,
        key: e.target.name,
        value: e.target.value,
      }),
    );
  };
  const bufferDataRows = useMemo(
    () => TitrationRowRenderer({ bufferDataPoints, handleDataPointChange }),
    [bufferDataPoints],
  );

  const handleSelectionChange = (rowIndices) => {
    setSelectedRows([...rowIndices]);
  };

  const handleAddStock = () => {
    dispatch(
      addBufferDataPoint({
        id: getNewId(),
        ingredientId: ingId,
        ph: 0,
        ratio: 0,
        state: State.New,
      }),
    );
  };

  const handleDeleteStock = () => {
    dispatch(
      removeBufferDataPoint(
        selectedRows.map((i) => {
          return bufferDataPoints[i];
        }),
      ),
    );
    setSelectedRows([]);
  };

  const actionButtons = [
    {
      iconProps: { name: 'New', width: '2rem', height: '2rem' },
      onClick: handleAddStock,
      titleTip: 'Add New',
    },
    {
      iconProps: { subfolder: 'Setup', name: 'Remove', width: '2rem', height: '2rem' },
      onClick: handleDeleteStock,
      titleTip: 'Remove',
    },
  ];

  return (
    <div
      id="bufferdatatable-main-container"
      className="flex flex-col basis-9/12 max-h-[24vh]"
    >
      <RMTable
        rowExtraInfo={errors}
        data={[...bufferDataRows]}
        columns={BUFFER_DATA_COLUMNS}
        selectedIds={selectedRows}
        onCheckboxSelectionChange={handleSelectionChange}
        mainContainerStyle={styles.tableStyle}
      />
      <div
        id="bufferdatatable-buttons-wrapper"
        className="flex basis-1/5 px-2 align-center"
      >
        <ButtonsListContainer containerStyleClass="gap-1" buttonsList={actionButtons} />
      </div>
    </div>
  );
};

const styles: IStyle = {
  tableStyle: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flexBasis: '70%',
    maxHeight: '70%',
  },
};
